export { HeaderLeft, HeaderRow, ReportCardContainer } from '../components';

import { Box, styled, Text } from '@ltvco/refresh-lib/theme';

export const PersonLocation = styled(Text)(({ theme }) => ({
  color: theme.palette.text.secondary,
  display: 'block',
  marginBottom: 16,
}));

export const PersonLinkedSection = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});
